var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLoaderLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 64,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#969696",
    strokeWidth: 4,
    d: "M23.735 53.644H4.06l15.697-30.478 18.8 36.065 12.838-24.975"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 3,
    d: "M23.33 53.644H4.06l15.697-30.478 18.8 36.065L51.16 34.68"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#8CC1FF",
    strokeWidth: 4,
    d: "M37.327 24.552L47.343 4.585l26.492 48.158H54.039"
  }))));
}

export default SvgLoaderLogo;